import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';

import { deriveProactiveAIApiUrl } from '../../prebuilt/utils';
import type { EditorPluginAIProvider, ProactiveAIConfig } from '../../types';

export const getConfiguration = (
	editorPluginAIProvider: EditorPluginAIProvider,
): {
	isProactiveAISupported: boolean;
	proactiveAIConfig: ProactiveAIConfig;
} => {
	const { proactiveAIConfig, isFullPageExperimentsEnabled, allowProactiveAIFeatures } =
		editorPluginAIProvider;

	const isProactiveAISupported =
		!!isFullPageExperimentsEnabled &&
		!!allowProactiveAIFeatures &&
		// NOTE: We need to ensure the experiment gate is evaluated last. This is beacuse if the product hasn't enabled
		// the feature then we don't want to hit the gate check since it's not possible for that product to have
		// the feature, and thus avoid an exposure from occuring.
		!!editorExperiment('editor_ai_-_proactive_ai_improve_writing', 'test', { exposure: true });

	return {
		isProactiveAISupported,
		proactiveAIConfig: {
			...proactiveAIConfig,
			enabled: isProactiveAISupported,
			defaultToggledState: false,
			apiUrl: deriveProactiveAIApiUrl(),
			timings: {
				// disabling the current chunk checking
				currentChunks: -1,
				currentChunksMaxWait: 30000,
				nonCurrentChunks: 5000,
			},
			// We don't want a full page spell checker for this proative plugin
			documentSGChecker: undefined,
		},
	};
};
